export const TRANSLATION_SCOPE = 'loginModule';
export const TRANSLATION_LOGIN_SCOPE = [TRANSLATION_SCOPE, 'login'];
